module.exports = Object.freeze({
  City: {
    flagVatEnabled: 1,
  }
})